import { ReadField } from 'components/ReadField';
import type { BimContractQuery } from 'gql/graphql';
import { CollapseGroup, Text } from 'uikit';
import { formatDateToLocale, formatNumberToRu } from 'utils';

import type React from 'react';
import { useMemo } from 'react';

import { bimContractCommonCollapseStyle } from '../../BimContractEdit/components/BimContractEditCommonForm';

interface IBimContractReadCommonForm {
    data: BimContractQuery['bimContract']['data'];
}

const dateRenderer = (value: any) => <Text size="s">{formatDateToLocale(value)}</Text>;

export const sumRenderer = (value: any) =>
    value !== undefined && <Text size="s">{formatNumberToRu(Number(value), 2)}</Text>;

export const sumInRoublesRenderer = (value: any) =>
    value !== undefined && <Text size="s">{formatNumberToRu(Number(value), 0)} руб</Text>;

export const BimContractReadCommonForm: React.FC<IBimContractReadCommonForm> = (props) => {
    const { data } = props;

    const commonGroups = useMemo(
        () => [
            {
                label: 'Данные договора',
                content: (
                    <>
                        <ReadField value={data?.generalInfo?.subject} label="Предмет" />
                        <ReadField value={data?.generalInfo?.internalNumber} label="Внутренний номер" />
                        <ReadField value={data?.generalInfo?.customer} label="Заказчик" />
                        <ReadField value={data?.generalInfo?.customerAddress} label="Адрес заказчика" />
                        <ReadField value={data?.generalInfo?.contractor} label="Подрядчик" />
                        <ReadField value={data?.generalInfo?.contractorAddress} label="Адрес подрядчика" />
                    </>
                ),
            },
            {
                label: 'Даты договора',
                content: (
                    <>
                        <ReadField value={data?.generalInfo?.signingDate} label="Подписание" render={dateRenderer} />
                        <ReadField value={data?.generalInfo?.startDate} label="Начало действия" render={dateRenderer} />
                        <ReadField
                            value={data?.generalInfo?.finishDate}
                            label="Окончание действия"
                            render={dateRenderer}
                        />
                    </>
                ),
            },
            {
                label: 'Сумма договора',
                content: (
                    <>
                        <ReadField value={data?.cost?.contractPlanWithTax} label="Сумма с НДС" render={sumRenderer} />
                        <ReadField value={data?.cost?.contractPlan} label="Сумма без НДС" render={sumRenderer} />
                        <ReadField value={data?.cost?.contractPlanTax} label="НДС, 20%" render={sumRenderer} />
                    </>
                ),
            },
            {
                label: 'Дополнительно',
                content: <ReadField value={data?.generalInfo?.note} label="Примечание" />,
            },
        ],
        [data?.cost, data?.generalInfo],
    );

    const opened = useMemo(() => commonGroups.map((_, index) => index), [commonGroups]);

    return <CollapseGroup items={commonGroups} style={bimContractCommonCollapseStyle} opened={opened} />;
};

BimContractReadCommonForm.displayName = 'BimContractReadCommonForm';
